import {
  BookmarkIcon,
  DocumentTextIcon,
  EyeIcon,
  FlagIcon,
  HomeIcon,
  InformationCircleIcon,
  LinkIcon,
  Bars3Icon,
  ShoppingBagIcon,
  TagIcon,
  Squares2X2Icon,
  StopIcon,
  TruckIcon,
  ArrowUpCircleIcon,
  ArchiveBoxIcon,
  CheckCircleIcon,
  PaperClipIcon,
  ArrowsPointingOutIcon,
} from "@heroicons/react/24/outline";

import { lazy } from "react";

// Lazy load tab components for performance
const Artfair = lazy(() => import("./pages/Artfair"));
const Auctions = lazy(() => import("./pages/Auctions"));
const Condition = lazy(() => import("./pages/Condition"));
const Details = lazy(() => import("./pages/Details"));
const Provenance = lazy(() => import("./pages/Provenance"));
const Reservation = lazy(() => import("./pages/Reservation"));
const Sales = lazy(() => import("./pages/Sales"));
const Technical = lazy(() => import("./pages/Technical"));
const Consignment = lazy(() => import("./pages/Consignment"));
const Fabrication = lazy(() => import("./pages/Fabrication"));
const Holds = lazy(() => import("./pages/Holds"));
const Shipments = lazy(() => import("./pages/Shipments"));
const COA = lazy(() => import("./pages/COA"));
const Warehouse = lazy(() => import("./pages/Warehouse"));
const Job = lazy(() => import("./pages/Jobs"));
const Documents = lazy(() => import("./pages/Documents"));
const History = lazy(() => import("./pages/History"));

const routes = [
  {
    href: "/instance",
    icon: HomeIcon,
    name: "All Instances",
  },
  {
    element: Details,
    href: "details",
    icon: DocumentTextIcon,
    name: "Instance Details",
  },
  {
    element: Sales,
    href: "sales",
    icon: ShoppingBagIcon,
    name: "Sales",
  },
  {
    element: Holds,
    href: "holds",
    icon: StopIcon,
    name: "Holds",
  },
  {
    element: Consignment,
    href: "consignment",
    icon: TagIcon,
    name: "Consignment",
  },
  {
    element: Provenance,
    href: "provenance",
    icon: Bars3Icon,
    name: "Provenance",
  },
  {
    element: Auctions,
    href: "auctions",
    icon: FlagIcon,
    name: "Auctions",
  },
  {
    element: History,
    href: "history",
    icon: ArrowsPointingOutIcon,
    name: "History",
  },
  {
    element: Artfair,
    href: "artfairs",
    icon: LinkIcon,
    name: "Art Fairs",
  },
  {
    element: Shipments,
    href: "shipments",
    icon: TruckIcon,
    name: "Shipments",
  },
  {
    element: Condition,
    href: "conditions",
    icon: EyeIcon,
    name: "Condition",
  },
  {
    element: Technical,
    href: "technicals",
    icon: InformationCircleIcon,
    name: "Technical",
  },
  {
    element: Job,
    href: "jobs",
    icon: CheckCircleIcon,
    name: "Jobs",
  },
  {
    element: Warehouse,
    href: "warehouse",
    icon: ArchiveBoxIcon,
    name: "Warehouse",
  },
  {
    element: Fabrication,
    href: "fabrication",
    icon: Squares2X2Icon,
    name: "Fabrication",
  },
  {
    element: Reservation,
    href: "reservations",
    icon: BookmarkIcon,
    name: "Reservation",
  },
  {
    element: Documents,
    href: "documents",
    icon: PaperClipIcon,
    name: "Documents",
  },
  {
    element: COA,
    href: "coa",
    icon: ArrowUpCircleIcon,
    name: "COA",
  },
];

export default routes;
